export const system = {
    version: '3.0.0-alpha',
    deferred: function () {
        return $.Deferred();
    },
    uuid: function () {
        /* jshint -W016 */
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    },
    isUuid: function (uuid) {
        var reg = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
        return reg.test(uuid);
    },
    emptyUuid: '00000000-0000-0000-0000-000000000000',
    guard: {
        argumentNotNull: function (argValue, argName) {
            if (typeof argValue === "undefined" || argValue === null) {
                throw new Error("ArgumentNull exception : " + argName + " is null");
            }
        },
        argumentNotNullOrEmpty: function (argValue, argName) {
            if (typeof argValue === "undefined" || argValue === null || argValue === '') {
                throw new Error("ArgumentNull exception : " + argName + " is null or empty");
            }
        },
        argumentIsNumber: function (argValue, argName) {
            if (typeof argValue === "undefined" || argValue === null || typeof (argValue) !== "number") {
                throw new Error("Argument exception : " + argName + " is not a number");
            }
        },
        argumentIsOptionalNumber: function (argValue, argName) {
            if (argValue !== undefined && (argValue === null || typeof (argValue) !== "number")) {
                throw new Error("Argument exception : " + argName + " is not an optional number");
            }
        },
        argumentIsFunction: function (argValue, argName) {
            if (typeof argValue === "undefined" || argValue === null || typeof argValue !== 'function') {
                throw new Error("Argument exception : " + argName + " is not a function");
            }
        },
        argumentIsDefined: function (argValue, argName) {
            if (typeof argValue === "undefined") {
                throw new Error("Argument exception : " + argName + " is undefined");
            }
        }
    },
    messageTypes: { empty: 'empty', success: 'success', info: 'info', warning: 'warning', danger: 'danger' }
};